<template>
  <figure class="chart chart-two animate" :style="chartStyle">
    <svg role="img" xmlns="http://www.w3.org/2000/svg">
      <desc>Circular chart showing {{ percentage }}% value</desc>
      <circle class="circle-background" :r="radius" :cx="size / 2" :cy="size / 2"/>
      <circle
          class="circle-foreground"
          :r="radius"
          :cx="size / 2"
          :cy="size / 2"
          :stroke-dasharray="circumference"
          :stroke-dashoffset="offset"
      />
    </svg>
    <figcaption>{{ text }}</figcaption>
  </figure>
</template>

<script>
export default {
  name: "CircularChart",
  props: {
    text: {
      type: String,
      required: true
    },
    percentage: {
      type: Number,
      required: true
    },
    size: {
      type: Number,
      default: 200
    }
  },
  computed: {
    strokeWidth() {
      return 15;
    },
    radius() {
      return (this.size - this.strokeWidth) / 2;
    },
    circumference() {
      return 2 * Math.PI * this.radius;
    },
    offset() {
      return this.circumference * (1 - this.percentage / 100);
    },
    chartStyle() {
      return {
        width: this.size + 'px',
        height: this.size + 'px'
      };
    }
  }
};
</script>

<style scoped>
.chart {
  position: relative;
  margin: 0;
}

svg {
  width: 100%;
  height: 100%;
}

.circle-background {
  fill: none;
  stroke: #006d75;
  stroke-width: 15px;
}

.circle-foreground {
  fill: none;
  stroke: #00f0ff;
  stroke-width: 15px;
  stroke-linecap: round;
  transform-origin: 50% 50%;
  transform: rotate(-90deg);
  transition: stroke-dashoffset 3s ease-in-out;
}

figcaption {
  position: absolute;
  top: 50%;
  left: 0;
  width: 100%;
  transform: translateY(-50%);
  text-align: center;
  color: white;
  font-size: 1rem;
}
</style>
